var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCronosPair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 300,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115 191.731L300 85L485 191.731V405.192L300 511.923L115 405.192V191.731ZM226.964 177.278H372.665L390.09 251.396H209.91L226.964 177.278ZM264.037 350.715L268.857 304.391L252.915 262.885H347.083L331.512 304.391L335.961 350.715H299.628H264.037ZM373.036 428.54H346.713L315.2 399.634V384.81L347.825 353.68V304.391L390.461 276.597L439.028 313.285L373.036 428.54ZM254.028 428.91L285.541 399.633V384.81L252.916 353.68V304.391L209.91 276.967L160.972 313.285L227.334 428.91H254.028Z",
    fill: "#03316C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCronosPair);
export default __webpack_public_path__ + "static/media/cronos-pair.f3a0668d147ae5510a00af1d2fb313ca.svg";
export { ForwardRef as ReactComponent };